module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.props) ? _c('div', {
    staticClass: "custom-platinum"
  }, [_c('div', {
    staticClass: "custom-platinum__container"
  }, [_c('div', {
    staticClass: "custom-platinum__header",
    style: ({
      backgroundImage: 'url(' + _vm.props.acf.platinum.header_img + ')'
    })
  }, [_c('div', {
    staticClass: "custom-platinum__icon-outer"
  }, [_c('div', {
    staticClass: "custom-platinum__icon-inner"
  }, [_c('Icon', {
    staticClass: "custom-platinum__icon custom-platinum__icon--shield",
    attrs: {
      "name": "shield"
    }
  })], 1)]), _c('div', {
    staticClass: "custom-platinum__text",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.platinum.text)
    }
  })]), _c('div', {
    staticClass: "custom-platinum__table"
  }, [_c('div', {
    staticClass: "custom-platinum__table-header"
  }, [_c('div', {
    staticClass: "custom-platinum__table-head-left",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.platinum.table_head)
    }
  }), _vm._m(0)]), _c('div', {
    staticClass: "custom-platinum__rows-container"
  }, _vm._l((_vm.props.acf.platinum.rows), function(row, i) {
    return _c('div', {
      staticClass: "custom-platinum__row"
    }, [_c('div', {
      staticClass: "custom-platinum__row-text",
      domProps: {
        "innerHTML": _vm._s(row.text)
      }
    }), (row.r_four_el) ? _c('div', {
      staticClass: "custom-platinum__r-four-el"
    }, [_c('Icon', {
      staticClass: "custom-platinum__r-four-check",
      attrs: {
        "name": "check"
      }
    })], 1) : _vm._e(), (row.platinum) ? _c('div', {
      staticClass: "custom-platinum__platinum"
    }, [_c('Icon', {
      staticClass: "custom-platinum__platinum-check",
      attrs: {
        "name": "check"
      }
    })], 1) : _vm._e()])
  }), 0)])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-platinum__table-head-right"
  }, [_c('div', {
    staticClass: "custom-platinum__r-four-el-head"
  }, [_vm._v("r4l")]), _c('div', {
    staticClass: "custom-platinum__platinum-head"
  }, [_vm._v("r4l platinum")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04b38325","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-platinum/custom-platinum.pug
// module id = 666
// module chunks = 1